import React from 'react'
import styled from '@emotion/styled'
import { H3 } from '../../../../layouts/TextStyles'
import { Button, DialogContent, FormHelperText } from '@mui/material'
import CustomInput from '../../../../components/muiComponents/customInput'
import { Box } from '@mui/system'
import FlagKz from '../../../../assets/img/flag-kz.png'
import FlagRu from '../../../../assets/img/flag-ru.png'
import { useIntl } from 'react-intl'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { Lorum } from '../../../../utils/constants'
import { tone, ui } from '../../../../utils/uiTokens'

const AddSubjectDialogContent = ({
    onImageChange,
    formik,
    image,
    editSubject,
}) => {
    const { formatMessage } = useIntl()

    const uploadPicture = () => (
        <Box>
            <Button
                component="label"
                variant="outlined"
                color="primary"
                startIcon={<FileUploadIcon />}
            >
                Сурет жүктеу
                <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={onImageChange}
                />
            </Button>

            <FormHelperText style={{ color: tone.bad.text, marginLeft: '12px' }}>
                {formik.touched.logo && formik.errors.logo}
            </FormHelperText>

            {formik.values.logo && (
                <ImageDiv>
                    <img
                        alt={'logo'}
                        src={image}
                        style={{
                            color: ui.pink,
                            width: '48px',
                            height: '48px',
                        }}
                    />
                    <span>{formik.values.logo['name']}</span>
                </ImageDiv>
            )}

            {!formik.values.logo && editSubject?.logo && (
                <ImageDiv>
                    <img
                        alt={'logo'}
                        src={editSubject?.logo}
                        style={{
                            color: ui.pink,
                            width: '48px',
                            height: '48px',
                        }}
                    />

                    <span>{editSubject?.logo}</span>
                </ImageDiv>
            )}
        </Box>
    )

    return (
        <DialogContent>
            <Wrapper>
                <div>
                    <form onSubmit={formik.handleSubmit}>
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2, 1fr)',
                                gap: 8,
                            }}
                        >
                            <Box
                                display={'flex'}
                                flexDirection="column"
                                minWidth={500}
                            >
                                <Box sx={{ height: '160px' }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <H3>Пән аты</H3>
                                        <img
                                            alt="flag"
                                            src={FlagKz}
                                            style={{
                                                width: 24,
                                                height: 24,
                                                marginLeft: 10,
                                                marginTop: 6,
                                            }}
                                        />
                                    </Box>

                                    <CustomInput
                                        id="titleKz"
                                        name="titleKz"
                                        placeholder="Enter name"
                                        fullWidth
                                        value={formik.values.titleKz}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        helperText={formik.errors.titleKz}
                                        error={Boolean(formik.errors.titleKz)}
                                    />
                                </Box>

                                <Box>
                                    <H3>Пән сипаттамасы</H3>

                                    <CustomInput
                                        id="descriptionKz"
                                        name="descriptionKz"
                                        placeholder={Lorum}
                                        fullWidth
                                        multiline
                                        maxRows={10}
                                        minRows={10}
                                        value={formik.values.descriptionKz}
                                        onChange={formik.handleChange}
                                        error={Boolean(
                                            formik.errors.descriptionKz,
                                        )}
                                        helperText={formik.errors.descriptionKz}
                                    />
                                </Box>

                                {uploadPicture()}
                            </Box>

                            <Box
                                display={'flex'}
                                flexDirection="column"
                                minWidth={500}
                            >
                                <Box sx={{ height: '160px' }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <H3>Название предмета</H3>

                                        <img
                                            alt="flag"
                                            src={FlagRu}
                                            style={{
                                                width: 24,
                                                height: 24,
                                                marginLeft: 10,
                                                marginTop: 6,
                                            }}
                                        />
                                    </Box>
                                    <CustomInput
                                        id="titleRu"
                                        name="titleRu"
                                        placeholder="Enter name"
                                        value={formik.values.titleRu}
                                        onChange={formik.handleChange}
                                        fullWidth
                                        helperText={formik.errors.titleRu}
                                        error={Boolean(formik.errors.titleRu)}
                                    />
                                </Box>

                                <Box>
                                    <H3>Описание предмета</H3>

                                    <CustomInput
                                        id="descriptionRu"
                                        name="descriptionRu"
                                        placeholder={Lorum}
                                        fullWidth
                                        multiline
                                        maxRows={10}
                                        minRows={10}
                                        value={formik.values.descriptionRu}
                                        onChange={formik.handleChange}
                                        error={Boolean(
                                            formik.errors.descriptionRu,
                                        )}
                                        helperText={formik.errors.descriptionRu}
                                    />
                                </Box>

                                <Box mt={2}>
                                    <H3>{formatMessage({ id: 'subjectCode' })}</H3>

                                    <CustomInput
                                        id="code"
                                        name="code"
                                        placeholder="01"
                                        fullWidth
                                        value={formik.values.code}
                                        onChange={formik.handleChange}
                                        error={Boolean(formik.errors.code)}
                                        helperText={formik.errors.code}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </form>
                </div>
            </Wrapper>
        </DialogContent>
    )
}

export default AddSubjectDialogContent

const Wrapper = styled.div``

const ImageDiv = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`
